import React, { Component } from 'react'
import { useFormikContext, ErrorMessage } from 'formik'
import { connect } from 'react-redux'

import { TextInputNew, Wrapper } from 'SRC/ui/FormElementsNew'

export const NameSurname = () => {
  const formik = useFormikContext()
  
  console.log('namesurname')

  if (!formik.values) return null

  const nameError = formik.errors.newUser && formik.errors.newUser.name && formik.touched.newUser && formik.touched.newUser.name
    ? formik.errors.newUser.name
    : ''

  return (
    <React.Fragment>
      <Wrapper isError={nameError}>
        <TextInputNew
          id='newUser-name'
          name='newUser.name'
          title='Ime'
          isRequired
          value={formik.values.newUser.name}
          onChange={textValue => {
            console.log('textvalue', textValue)

            formik.setFieldValue('newUser.name', textValue)
          }}
        />

        <ErrorMessage
          name='newUser.name'
          render={msg => <span style={{ display: 'block', marginTop: 5 }} className='form-group__error-message'>{msg}</span>}
        />
      </Wrapper>

      <Wrapper>
        <TextInputNew
          id='newUser-surname'
          name='newUser.surname'
          title='Prezime'
          value={formik.values.newUser.surname}
          onChange={async textValue => {
            console.log('textvalue', textValue)

            await formik.setFieldValue('newUser.surname', textValue)
          }}
        />

        <ErrorMessage
          name='newUser.surname'
          render={msg => <span style={{ display: 'block', marginTop: 5 }} className='form-group__error-message'>{msg}</span>}
        />
      </Wrapper>
    </React.Fragment>
  )
}

